module.exports = new __parcel__URL__("kitten3.11981e32.png").toString();